import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toHandlerKey as _toHandlerKey, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/person_gray_150.png'


const _withScopeId = n => (_pushScopeId("data-v-0d7657f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "modal-title" }, " Welcome! "),
  /*#__PURE__*/_createElementVNode("div", null, "Let's confirm a few things.")
], -1))
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "name-section" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "user-icon"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Preferred name", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, " This helps other people identify you as a user on the site. It should be your current preferred name. ", -1))
const _hoisted_9 = { class: "name-editor" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Given name", -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Surname", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "location-section" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Your location", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "help-text" }, " This can help distinguish you from other people with the same name. Just the city or state you live in is fine. ", -1))
const _hoisted_17 = { class: "profile-name" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "help-text"
}
const _hoisted_20 = { class: "modal-footer" }
const _hoisted_21 = ["disabled", "onClick"]

import { computed, nextTick, onMounted, ref } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import { Modal as BsModal } from 'bootstrap'
import { PatchChange } from '@/util/Api'
import { MapPinIcon } from '@zhuowenli/vue-feather-icons'
import Spinner from '@/util/Spinner.vue'
import { AsyncUtil } from '@/util/AsyncUtil'

const shownEvent = 'shown.bs.modal'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserNameConfirmModal',
  setup(__props, { expose: __expose }) {

__expose({
  open
})

const busyRef = ref(false)
const editGivenNameRef = ref('')
const editSurnameRef = ref('')
const editLocationRef = ref('')
const locationGuessedRef = ref(false)

const userStore = useUserStore()

const userRef = computed(() => userStore.getAsyncSelf()?.data) // loaded by app
const areChangesValidRef = computed(() => (!!editGivenNameRef.value.trim() || !!editSurnameRef.value.trim()))
const enableSaveRef = computed(() => !busyRef.value && areChangesValidRef.value)

const modalRef = ref<HTMLElement>()
const givenNameInputRef = ref<HTMLInputElement>()

function open() {
  editGivenNameRef.value = userRef.value?.givenName ?? ''
  editSurnameRef.value = userRef.value?.surname ?? ''
  editLocationRef.value = userRef.value?.metadata?.location ?? ''
  locationGuessedRef.value = !!editLocationRef.value

  // HACK: Not sure why getInstance isn't sufficient here, but sometimes it returns null because apparently the BS Modal
  // hasn't been initialized yet. Calling getOrCreateInstance seems to fix it.
  BsModal.getOrCreateInstance(modalRef.value!).show()
}

async function save() {
  if (!userRef.value)
    throw new Error('User not loaded')

  try {
    busyRef.value = true

    const changes = [
      new PatchChange('/metadata/nameConfirmed', 'true')
    ]

    if (editGivenNameRef.value != (userRef.value?.givenName ?? '')) {
      changes.push(new PatchChange('/givenName', editGivenNameRef.value))
    }
    if (editSurnameRef.value != (userRef.value?.surname ?? '')) {
      changes.push(new PatchChange('/surname', editSurnameRef.value))
    }
    if (editLocationRef.value != (userRef.value?.metadata?.location ?? '')) {
      changes.push(new PatchChange('/metadata/location', editLocationRef.value))
    }

    await AsyncUtil.atLeast(500, userStore.patchAsync(userRef.value.id!, changes))

    BsModal.getInstance(modalRef.value!)?.hide()
  }
  finally {
    busyRef.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    ref_key: "modalRef",
    ref: modalRef,
    class: "modal",
    "data-bs-backdrop": "static",
    tabindex: "-1"
  }, {
    [_toHandlerKey(shownEvent)]: _cache[3] || (_cache[3] = ($event: any) => (givenNameInputRef.value?.focus()))
  }), [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  ref_key: "givenNameInputRef",
                  ref: givenNameInputRef,
                  class: "form-control",
                  disabled: busyRef.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editGivenNameRef).value = $event))
                }, null, 8, _hoisted_11), [
                  [_vModelText, editGivenNameRef.value]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_12,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  disabled: busyRef.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editSurnameRef).value = $event))
                }, null, 8, _hoisted_13), [
                  [_vModelText, editSurnameRef.value]
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_14, [
            _createVNode(_unref(MapPinIcon), { size: "1.8x" }),
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                disabled: busyRef.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((editLocationRef).value = $event)),
                placeholder: "Anytown, ST"
              }, null, 8, _hoisted_18), [
                [_vModelText, editLocationRef.value]
              ])
            ]),
            (locationGuessedRef.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, " We took a guess based on your device's internet address. Just correct it if it's wrong. "))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary",
            disabled: !enableSaveRef.value,
            onClick: _withModifiers(save, ["prevent"])
          }, [
            (busyRef.value)
              ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
              : _createCommentVNode("", true),
            _createTextVNode(" Confirm ")
          ], 8, _hoisted_21)
        ])
      ])
    ])
  ], 16))
}
}

})